// console.error(">>>>>> Script is loaded 1");

window.breeze = {
  onCheckoutButtonClick: async (props) => {
    if (props !== null) {
      try {
        const res = await onProductPage(props);
        return res;
      } catch (e) {
        console.error("Exception: ", e);
      }
    }
    return {
      checkoutFlag: true,
      offerCode: getDiscountCodeFromCookies(),
    };
  },
};

function getDiscountCodeFromCookies() {
  const cookies = document.cookie.split(";");
  const discountCookie = cookies.find((cookie) =>
    cookie.trim().startsWith("discount_code=")
  );
  if (discountCookie) {
    return discountCookie.split("=")[1];
  }
  return null;
}

async function onProductPage(props) {
  try {
    const decodedProps = atob(props);
    const jsonProps = JSON.parse(decodedProps);
    const cartItems = jsonProps !== null ? [jsonProps] : [];
    if (cartItems !== null && cartItems.length > 0) {
      return {
        checkoutFlag: true,
        offerCode: getDiscountCodeFromCookies(),
      };
    }
  } catch (e) {
    console.error("Breeze| Exception| onProductPage: ", e);
  }
  return true;
}